import './index.sass';

export default () => {
  $('#upload').change(function() {
    $('.upload__loader').addClass('upload__loader--show');
    return $(this).closest('form').submit();
  });
}